export default "__VITE_ASSET__B0a_NWy___"